import React from "react";
import { useTranslation } from "react-i18next";
import classes from "./HistoryCard.module.css";

export default function OHistoryCard(props) {
    const [tg, i18n] = useTranslation("global");
    
    return (
        <div className={classes.box}>
        <h1>{props.title}</h1>
        <p>{tg("stats.card.dateTime")}: {props.date}</p>
        <p>{tg("stats.card.progress")}: {props.progress}</p>
        <p>{tg("stats.card.totalTimes")}: {props.totalTimes}</p>
        <p>{tg("stats.card.pointValue")}: {props.pointValue}</p>
        </div>
    );
    }